import Vue from 'vue'
import App from './App.vue'

import { BootstrapVue, IconsPlugin } from 'bootstrap-vue';
import VueResource from 'vue-resource';
import VueCookie from 'vue-cookie';
import VueGtag from "vue-gtag";
import VueGtm from '@gtm-support/vue2-gtm';

import VueRouter from 'vue-router';
import Header from './Components/Header.vue';
import HeaderInterior from './Components/HeaderInterior.vue';
import Home from './Home/Home.vue';

Vue.config.productionTip = false

Vue.use(BootstrapVue);
Vue.use(IconsPlugin);



import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';

import "aos/dist/aos.css";

import '@fortawesome/fontawesome-free/css/all.css';
import '@fortawesome/fontawesome-free/js/all.js';

import "./assets/css/style.scss";

import { routes } from './routes';
import { store } from './Store/store';

Vue.component('home', Home);
Vue.component('header-mx', Header);

Vue.component('header-interior', HeaderInterior);

Vue.use(VueResource);
Vue.use(VueRouter);
Vue.use(VueCookie);




const router = new VueRouter({
    routes,
    scrollBehavior(to, from, savedPosition) {
        return { x: 0, y: 0 }
    },
    mode: 'history'
});

Vue.use(VueGtag, {
    config: { id: "G-YZVD755CYQ" }
}, router);



// // // Vue.use(VueGtm, {
// // //     id: 'GTM-W4ZRLVB', // Your GTM single container ID or array of container ids ['GTM-xxxxxx', 'GTM-yyyyyy'] or array of objects [{id: 'GTM-xxxxxx', queryPararms: { gtm_auth: 'abc123', gtm_preview: 'env-4', gtm_cookies_win: 'x'}}, {id: 'GTM-yyyyyy', queryParams: {gtm_auth: 'abc234', gtm_preview: 'env-5', gtm_cookies_win: 'x'}}]
// // //     queryParams: {
// // //         // Add url query string when load gtm.js with GTM ID (optional)
// // //         gtm_auth: 'AB7cDEf3GHIjkl-MnOP8qr',
// // //         gtm_preview: 'env-4',
// // //         gtm_cookies_win: 'x'
// // //     },
// // //     defer: false, // defaults to false. Script can be set to `defer` to increase page-load-time at the cost of less accurate results (in case visitor leaves before script is loaded, which is unlikely but possible)
// // //     enabled: true, // defaults to true. Plugin can be disabled by setting this to false for Ex: enabled: !!GDPR_Cookie (optional)
// // //     debug: true, // Whether or not display console logs debugs (optional)
// // //     loadScript: true, // Whether or not to load the GTM Script (Helpful if you are including GTM manually, but need the dataLayer functionality in your components) (optional)
// // //     vueRouter: router, // Pass the router instance to automatically sync with router (optional)
// // //     ignoredViews: ['homepage'], // Don't trigger events for specified router names (case insensitive) (optional)
// // //     trackOnNextTick: false // Whether or not call trackView in Vue.nextTick
// // // });


new Vue({
    store,
    router,
    render: h => h(App),
}).$mount('#app')